import { useActivateAllyMutation } from '@http';
import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';
import { Modal } from '@components/ui/Modal';
import { useAppStore } from '@stores';

interface ActivateAllyProps {
  allyId: string;
  onClose: () => void;
};

export function ActivateAlly({ allyId, onClose }: ActivateAllyProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Hub.Allies' });
  const { mutateAsync } = useActivateAllyMutation();
  const { refetch, setIsFetching } = useAppStore();

  const activate = async () => {
    setIsFetching(true);
    await mutateAsync({ id: allyId });
    refetch();
    onClose();
  };

  return (
    <Modal title={t('activateModal')} onRequestClose={onClose} isOpen={!!allyId}>
      <p className="text-center text-sm text-shield mt-4 px-2">
        {t('activateDescription')}
      </p>

      <Button className="mt-4 border-0 border-t" onClick={activate}>
        {t('activate')}
      </Button>
    </Modal>
  );
}